// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\AutomationSystem\ApiAutomationSystem.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';

// AutomationSystemData is the class that AutomationSystem serializes to/from
export interface AutomationSystemData {
    Id : number;
	
    Domain : DomainData | null;
    DomainId : number;
	
    Active : boolean;
    Description : string | null;
    Name : string | null;
    Type : string | null;
}

// AutomationSystemOptions is the class which may be passed to the AutomationSystem constructor to define optional initial data values
export interface AutomationSystemOptions {
    Id : number;
	
    Domain? : DomainOptions | null;
    DomainId? : number;
	
    Active? : boolean;
    Description? : string | null;
    Name? : string | null;
    Type? : string | null;
}

export class AutomationSystem {
    public Id : DataSignal<number>;
	
    public Domain : DataSignal<Domain | null>;
    public DomainId : DataSignal<number>;
	
    public Active : DataSignal<boolean>;
    public Description : DataSignal<string | null>;
    public Name : DataSignal<string | null>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : AutomationSystemOptions);
    constructor(data: AutomationSystemOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Domain = S.value<Domain | null>(null);
        this.DomainId = jsonableObservable(S.value<number>(data && data.DomainId !== undefined ? data.DomainId : 0));
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : AutomationSystem) {
        return obj.Id();
    }
    
    static dataKey(obj : AutomationSystemOptions) {
        return obj.Id;
    }

    static update(obj : AutomationSystem, data : AutomationSystemOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.DomainId !== undefined) obj.DomainId(data.DomainId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AutomationSystem.ts